const storageName = {name:'qh_backend'};

export default {
  /* community */

  _getDataFromStorage(ob, k){
    // console.log("_getDataFromStorage[%s] ob:%o, k:%s", storageName.name, ob, k);
    let sd = ob.getItem(storageName.name);
    // console.log("_getDataFromStorage sd:%s", sd);
    if(sd){
      let od = JSON.parse(sd)
      // console.log("_getDataFromStorage od:%o", od);
      if(od.hasOwnProperty(k)){
        // console.log("_getDataFromStorage od.k:%o", od[k]);
        return od[k];
      }
    }
    return false;
  },

  _setDataToStorage(ob, k, v){
    // console.log("_setDataToStorage[%s] ob:%o, k:%s, v:%o", storageName.name, ob, k, v);
    let sd = ob.getItem(storageName.name);
    // console.log("_setDataToStorage sd:%s", sd);
    if(sd){
      let od = JSON.parse(sd)
      // console.log("_setDataToStorage od:%o", od);
      od[k] = v;
      ob.setItem(storageName.name, JSON.stringify(od));
    }else{
      let od = {};
      od[k] = v;
      ob.setItem(storageName.name, JSON.stringify(od));
    }
    return true;
  },

  _delDataFromStorage(ob, k){
    // console.log("_delDataFromStorage[%s] ob:%o, k:%s", storageName.name, ob, k);
    let sd = ob.getItem(storageName.name);
    // console.log("_delDataFromStorage sd:%s", sd);
    if(sd){
      let od = JSON.parse(sd)
      // console.log("_delDataFromStorage od:%o", od);
      od[k] = '';
      delete od[k];
      ob.setItem(storageName.name, JSON.stringify(od));
    }
    return true;
  },


  getData(k, m){
    // console.log("getData m:%s, k:%s", m, k);
    if(m){
      // console.log("getData from localStorage");
      return this._getDataFromStorage(localStorage, k);
    }else{
      // console.log("getData from sessionStorage");
      return this._getDataFromStorage(sessionStorage, k);
    }
  },

  setData(k, v, m){
    // console.log("setData m:%s, k:%s, v:%o", m, k, v);
    if(m){
      // console.log("setData from localStorage");
      return this._setDataToStorage(localStorage, k, v);
    }else{
      // console.log("setData from sessionStorage");
      return this._setDataToStorage(sessionStorage, k, v);
    }
  },

  delData(k, m){
    // console.log("delData m:%s, k:%s", m, k);
    if(m){
      // console.log("delData from localStorage");
      return this._delDataFromStorage(localStorage, k);
    }else{
      // console.log("delData from sessionStorage");
      return this._delDataFromStorage(sessionStorage, k);
    }
  }

}



// WEBPACK FOOTER //
// ./src/storage.js